import { z } from 'zod'

export const trainerXanoInvoiceExceptionResponseSchema = z.record(z.unknown())
export type TrainerXanoInvoiceExceptionResponse = z.infer<typeof trainerXanoInvoiceExceptionResponseSchema>
